import React from 'react';
import { TimelineEntry } from './TimelineEntry';
import { useFadeInOnScroll } from '../hooks/useFadeInOnScroll';
import timelineData from '../data/timeline.json';

import type { TimelineItem } from './TimelineEntry';

export function EventsTimeline() {
  const { ref, style } = useFadeInOnScroll<HTMLElement>();

  return (
    <section
      ref={ref}
      className="events-timeline"
      aria-labelledby="timeline-title"
      style={style}
    >
      <h2 id="timeline-title" className="section-eyebrow">
        Global Momentum
      </h2>
      <ol className="events-timeline__list">
        {(timelineData as TimelineItem[]).map((item, i) => (
          <TimelineEntry key={item.date + item.location} item={item} index={i} />
        ))}
      </ol>
    </section>
  );
}
